import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest/none, object=user
  const [loading, setLoading] = useState(true);
  const [usage, setUsage] = useState(null); // {applies, coins_remaining, ...}

  const refreshUsage = useCallback(async () => {
    try {
      const { data } = await api.get("/usage");
      setUsage(data);
      return data;
    } catch {
      setUsage(null);
      return null;
    }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      if (data?.paid) refreshUsage();
      else setUsage(null);
    } catch {
      setUser(false);
      setUsage(null);
    } finally {
      setLoading(false);
    }
  }, [refreshUsage]);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const register = async (email, password) => {
    const { data } = await api.post("/auth/register", { email, password });
    setUser(data);
    return data;
  };
  const guest = async () => {
    const { data } = await api.post("/auth/guest");
    setUser(data);
    return data;
  };
  const claim = async (email, password) => {
    const { data } = await api.post("/auth/claim", { email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, guest, claim, logout, refresh, usage, setUsage, refreshUsage }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
